import { VStack, useRadioGroup } from '@chakra-ui/react';

import { RadioCard } from '../RadioCard';

export const VerRadioGroup = ({ name, options, onChange, defaultValue }) => {
	const { getRootProps, getRadioProps } = useRadioGroup({
		defaultValue,
		name,
		onChange,
	});
	const group = getRootProps();
	const values = Object.keys(options);
	return (
		<VStack w="100%" {...group}>
			{values.map(value => {
				const radio = getRadioProps({ value });
				return (
					<RadioCard w="100%" key={value} {...radio}>
						{options[value]}
					</RadioCard>
				);
			})}
		</VStack>
	);
};
